<template>
    <h1 class="xa-title" :style="styleObj">{{headerName}}</h1>
</template>

<script>
export default {
    name: 'de-header-title',
    props: {
        headerName: {
            type: [String, Number],
            default: '市民服务中心分析'
        },
        fontObj: {
            type: Object
        },
        paddingLeft: {
            type: Number,
            default: 20
        },
        lineHeight: {
            type: Number,
            default: 60
        },
        backgroundColor: {
            type: String,
            default: 'linear-gradient(rgba(0,255,0,0), rgba(0, 67, 255, 0.5))'
        }
    },
    computed: {
        styleObj() {
            return this.fontObj && (Object.assign({}, this.fontObj, {
                fontSize: `${this.fontObj.fontSize}px`,
                fontStyle: this.fontObj.fontStyle,
                fontFamily: this.fontObj.fontFamily,
                fontWeight: this.fontObj.fontWeight,
                color: this.fontObj.color,
                paddingLeft: `${this.paddingLeft}px`,
                lineHeight: `${this.lineHeight}px`,
                background: this.backgroundColor
            }));
        }
    }
}
</script>

<style lang="less">
.xa-title {
    font-weight: normal;
    letter-spacing: 2px;
    background-image: linear-gradient(0deg, rgba(0,85,255,0.50) 0%, rgba(0,85,255,0.15) 91%);
    font-family: 'PingFangSC-Medium';
}
</style>